import React, { useState } from 'react';
import { usePopoverContext } from '../../Popover';
import { Button } from 'components/core/Button';
import { ButtonProps } from 'components/core/Button/Button.d';

type Props = {
  beforeClose: () => Promise<any>;
  children: React.ReactNode;
  isLoading?: boolean;
} & ButtonProps;

export const AsyncPopoverCloseButton = ({
  beforeClose,
  children,
  isLoading,
  ...rest
}: Props) => {
  const { setIsOpen, onClose } = usePopoverContext();
  const [asyncRunning, setAsyncRunning] = useState(false);

  // Use external isLoading if provided, otherwise use internal asyncRunning state
  const isButtonLoading = isLoading !== undefined ? isLoading : asyncRunning;

  return (
    <Button
      onClick={async () => {
        setAsyncRunning(true);
        try {
          await beforeClose();
          // Could set asyncRunning to false at this point, however it can result in the React setting state on
          // unmounted component warning.
          // Because the popover will be closed after this, not setting the state is fine - the state will be reset
          // anyway the next time the popover is opened.
          setIsOpen(false);
          onClose && onClose();
        } catch {
          setAsyncRunning(false);
          setIsOpen(true);
        }
      }}
      isLoading={isButtonLoading}
      disabled={isButtonLoading}
      {...rest}
    >
      {children}
    </Button>
  );
};
